
const black = '#000000';
const eerieBlack = '#1a1b1f';
const clinkBlack = '#212529';
const grayDark = '#f0f0f0';
const darkLightGrey = '#818286';
const grayLight = '#f9f9f9';
const white = '#ffffff';
const clinkGreen = '#4cc0ad';
const clinkGreenDark = '#4aac9c';
const clinkGreenHover = '#4cc0a1';
const clinkDefaultHover = '#c8cbcb';
const aliceBlue = '#f3f7f9';
const casal = '#3e5159';
const elephant = '#2d3a41';
const clinkGray = '#959595';
const clinkGrayV2 = '#969ca0';
const brightGray = '#EDEDED';
const clinkLightPurple = '#e2e2ee';
const whiteSmoke = '#f2f2f2';
const ghostWhite = '#f9f9fc';
const ghostWhite2 = '#F8F8FB';
const clinkPurple = '#8e8dbe';
const lightPeriwinkle = '#C6C5DE';
const clinkRed = '#ed1164';
const clinkOrange = '#ff9300';
const metallicSilver = '#a0aeb4';
const clinkDarkGray = '#273339';
const cultured = '#f4f4f4';
const platinum = '#e3e3e3';
const platinum2 = '#DFDFEA';
const striped = '#f0fafd';
const lightBlue = '#59c9f9';
const clinkShadowGray = '#2D3A4150';
const clinkBlueGray = '#96B7C9';
const darkBlue = '#3c6b84';
const redButton = '#dd1900';
const greenButton = '#158b00';
const bluishGray = '#dce7ed';
const blueScrollBg = '#b6d8e2';
const blueScrollBgHover = '#88b2bf';
const japaneseIndigo = '#2b3946';
const darkJungleGreen = '#08202a';
const blueMagentaViolet = '#59358C';
const russianViolet = '#270C4E';
const vistaBlue = '#8493E199';
const magnolia = '#F3F3FC';
const highlightGray = '#F3F3F9';
const stPatricksBlue = '#1E2D7B';
const clearBlue = '#1E2D7B';
const azureishWhite = '#D6DBF5';
const outerSpace = '#2D3A419B';
const boxShadowProsper = '#00000029';
const draftGray = '#BEBED1';
const yellow = '#ffff00';
const spanishGray = '#95989a';
const red = '#ff0000';
const culturedGrey = '#f3f3f980';
const heatWave = '#ff7900';
const lavenderBlush = '#fdf0f0';
const clinkBleumarine = '#405090';
const brightGray2 = '#ececf8';
const darkCharcoal = '#313237';
const ruby = '#e81c5c';
const clinkPurple2 = '#8e8dbe80';
const christalle = '#3C2857';
const darkSlateBlue = '#4D4D88';
const razzmatazz = '#DB0A59';
const clinkLightGray = '#eaeaea';
const clinkBackgroundPurple = '#f3f3f8';
const brightGray3 = '#E5F0F5';
const gray2 = '#31323799';
const bostonRed = '#C80202';
const webOrange = '#FFA500';
const transparentGray = '#A1A1A1A6';
const magnesium = '#C2C2C2';
const prim = '#E3E1E2';
const christmasSilver = '#E0E0E0';
const darkGray = '#B0B0B0';
const teal = '#4bc0ac';
const teal2 = '#008080';
const amber = '#FF8C00';
const darkerRed = '#B22222';
const tealShade = '#009688';
const lightGray3 = '#F5F5F5';
const charcoalGray = '#212121';
const mediumGray = '#757575';
const lightCyan = '#E0F7FA';
const borderbox = '#F3F4F6';
const lightGreen = '#4EC5B6';
const lightGreenBg = '#D4EDDA';
const lighterBlue = '#E3F2FD';
const grayBlue = '#1E88E5';
const approvedGreen = '#16a34a';
const approvedGreenBg = '#dcfce7';
const rejectedRed = '#dc2626';
const rejectedRedBg = '#fee2e2';
const pendingAmber = '#d97706';
const pendingAmberBg = '#fef3c7';
const lockedGray = '#6b7280';
const lockedGrayBg = '#f3f4f6';
const mutedGray = '#9ca3af';
const borderGray = '#e5e7eb';
const surfaceGray = '#f9fafb';
const inkBlack = '#111827';
const hoverGray = '#fafafa';
// Empty State
const aiEmptyBg = '#eff6ff';
const aiEmptyBorder = '#bfdbfe';
const aiEmptyChipBg = '#dbeafe';
const aiEmptyChipLabel = '#1d4ed8';

// Ineligible State
const aiIneligibleBg = '#f9fafb';
const aiIneligibleBorder = '#e5e7eb';
const aiIneligibleChipBg = '#e5e7eb';
const aiIneligibleChipLabel = '#4a5565';

// Eligible State
const aiEligibleBg = '#e2f5f1';
const aiEligibleBorder = '#f6f8f9';
const aiEligibleChipBg = '#fce7f3';
const aiEligibleChipLabel = '#be185d';
const aiAnalysisToolsBetaBg = '#FEF3C7';
const aiAnalysisToolsBetaLabel = '#B45309';
const aiAnalysisToolsPanelBorder = '#DDE3EA';
const aiEligibleIcon = '#0d9488';
const aiEligibleIconText = '#0d9488';
const softAmber = '#fef3c7';
// Analysis tool card status chips
const aiToolNotRunChipBg = '#e5e7eb';
const aiToolNotRunChipLabel = '#4a5565';
const aiToolRunningChipBg = '#FEF3C7';
const aiToolRunningChipLabel = '#B45309';
const aiToolReadyChipBg = '#ccfbf1';
const aiToolReadyChipLabel = '#0d9488';
const aiToolReadyDot = '#0d9488';
const aiToolFailedChipBg = '#fee2e2';
const aiToolFailedChipLabel = '#dc2626';
const aiToolFailedDot = '#dc2626';
const aiToolLevelingFailedBg = '#fce7f3';
const aiToolLevelingFailedBorder = '#f9a8d4';
const aiToolLevelingFailedChipBg = '#fce7f3';
const aiToolLevelingFailedChipLabel = '#be185d';
const aiToolLevelingFailedDot = '#be185d';
const aiToolLevelingFailedMessage = '#be185d';
const aiToolLevelingRetryBg = '#db2777';
const aiToolCardBorder = '#DDE3EA';

// asite helper
const ahMaroon = '#b45309';
const ahLightBeige = '#fffae9';
const ahBeige = '#fef3c7';
const ahBeigeBorder = '#FCE2A1';
const ahGray = '#666666';
const ahGrayBorder = '#E3E5EB';

// BoQ (schedules) page accent + DataGrid section strip
const boqAccent = '#14A38B';
const boqAccentHover = '#128A75';
const boqSectionBg = '#F9FAFB';

const admin = {
  christmasSilver,
  prim,
  christalle,
  black,
  eerieBlack,
  clinkBlack,
  grayDark,
  grayLight,
  darkLightGrey,
  white,
  clinkGreen,
  clinkGreenDark,
  clinkGreenHover,
  lightGreen,
  clinkDefaultHover,
  aliceBlue,
  casal,
  elephant,
  clinkGray,
  clinkGrayV2,
  brightGray,
  clinkLightPurple,
  whiteSmoke,
  ghostWhite,
  ghostWhite2,
  clinkPurple,
  lightPeriwinkle,
  clinkRed,
  clinkOrange,
  metallicSilver,
  clinkDarkGray,
  cultured,
  platinum,
  platinum2,
  striped,
  lightBlue,
  clinkShadowGray,
  clinkBlueGray,
  darkBlue,
  redButton,
  greenButton,
  bluishGray,
  blueScrollBg,
  blueScrollBgHover,
  japaneseIndigo,
  darkJungleGreen,
  blueMagentaViolet,
  russianViolet,
  vistaBlue,
  magnolia,
  highlightGray,
  stPatricksBlue,
  clearBlue,
  azureishWhite,
  outerSpace,
  boxShadowProsper,
  draftGray,
  yellow,
  spanishGray,
  red,
  culturedGrey,
  heatWave,
  lavenderBlush,
  clinkBleumarine,
  brightGray2,
  darkCharcoal,
  ruby,
  clinkPurple2,
  darkSlateBlue,
  razzmatazz,
  clinkLightGray,
  clinkBackgroundPurple,
  brightGray3,
  gray2,
  bostonRed,
  webOrange,
  transparentGray,
  magnesium,
  darkGray,
  teal,
  teal2,
  amber,
  darkerRed,
  tealShade,
  lightGray3,
  charcoalGray,
  mediumGray,
  lightCyan,
  borderbox,
  lightGreenBg,
  grayBlue,
  lighterBlue,
  approvedGreen,
  approvedGreenBg,
  rejectedRed,
  rejectedRedBg,
  pendingAmber,
  pendingAmberBg,
  lockedGray,
  lockedGrayBg,
  mutedGray,
  borderGray,
  surfaceGray,
  inkBlack,
  hoverGray,
  softAmber,

  boqAccent,
  boqAccentHover,
  boqSectionBg,

  aiEmptyBg,
  aiEmptyBorder,
  aiEmptyChipBg,
  aiEmptyChipLabel,

  aiIneligibleBg,
  aiIneligibleBorder,
  aiIneligibleChipBg,
  aiIneligibleChipLabel,

  aiEligibleBg,
  aiEligibleBorder,
  aiEligibleChipBg,
  aiEligibleChipLabel,
  aiAnalysisToolsBetaBg,
  aiAnalysisToolsBetaLabel,
  aiAnalysisToolsPanelBorder,
  aiEligibleIcon,
  aiEligibleIconText,
  aiToolNotRunChipBg,
  aiToolNotRunChipLabel,
  aiToolRunningChipBg,
  aiToolRunningChipLabel,
  aiToolReadyChipBg,
  aiToolReadyChipLabel,
  aiToolReadyDot,
  aiToolFailedChipBg,
  aiToolFailedChipLabel,
  aiToolFailedDot,
  aiToolLevelingFailedBg,
  aiToolLevelingFailedBorder,
  aiToolLevelingFailedChipBg,
  aiToolLevelingFailedChipLabel,
  aiToolLevelingFailedDot,
  aiToolLevelingFailedMessage,
  aiToolLevelingRetryBg,
  aiToolCardBorder,

  ahMaroon,
  ahLightBeige,
  ahBeige,
  ahBeigeBorder,
  ahGray,
  ahGrayBorder
};

module.exports = admin;
